import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all duration-300 ease-smooth focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-md hover:bg-primary-light hover:shadow-lg active:scale-[0.98]",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-silver/30 bg-transparent text-silver hover:bg-silver/10 hover:border-silver/50 hover:text-silver-light",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90",
        ghost: 
          "text-foreground hover:bg-muted hover:text-foreground",
        link: 
          "text-silver underline-offset-4 hover:underline hover:text-silver-light",
        // Luxury variants for Fazila Creations
        ivory:
          "bg-ivory text-primary font-medium shadow-md hover:bg-ivory-muted hover:shadow-lg active:scale-[0.98]",
        silver:
          "border border-silver/40 bg-transparent text-silver hover:bg-silver/10 hover:border-silver hover:shadow-silver active:scale-[0.98]",
        premium:
          "bg-gradient-burgundy text-ivory border border-silver/20 shadow-lg hover:shadow-glow hover:border-silver/40 active:scale-[0.98]",
        whatsapp:
          "bg-[#25D366] text-primary-dark font-medium shadow-md hover:bg-[#22c55e] hover:shadow-lg active:scale-[0.98]",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 rounded-md px-4 text-xs",
        lg: "h-12 rounded-lg px-8 text-base",
        xl: "h-14 rounded-lg px-10 text-lg",
        icon: "h-10 w-10",
        "icon-sm": "h-8 w-8",
        "icon-lg": "h-12 w-12",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
